<template>
  <BBreadcrumb :items="convertedItems" />
</template>

<script>
import {BBreadcrumb} from 'bootstrap-vue/src/components/breadcrumb/breadcrumb'

export default {
  components: {
    BBreadcrumb,
  },

  props: {
    /**
     * Array of breadcrumb items to render.
     */
    items: {
      type: Array,
      required: true,
    },
  },

  computed: {
    convertedItems () {
      const convertedItems = [...this.items]
      for (let i = 0; i < convertedItems.length; i++) {
        const item = convertedItems[i]

        if (item.image) {
          item.html = `<img src="${item.image}" width="16" height="16" />`

          item.text = null
          item.image = null
        }
      }

      return convertedItems
    },
  },
}
</script>
